import { useSubscription } from '@apollo/client';
import { useMemo } from 'react';

import {
  Alert,
  AlertDescription,
  AlertTitle,
  LoadingIcon,
} from '@eluve/components';
import { useTranslation } from '@eluve/i18n';

import { pendingTranscriptionFilesSubscriptions } from './useAppointmentTranscriptionPendingFiles';

interface PendingTranscriptionLoaderProps {
  tenantId: string;
  appointmentId: string;
}

export const PendingTranscriptionLoader: React.FC<
  PendingTranscriptionLoaderProps
> = ({ tenantId, appointmentId }) => {
  const { t } = useTranslation();
  const { data: pendingFiles } = useSubscription(
    pendingTranscriptionFilesSubscriptions,
    {
      variables: { tenantId, id: appointmentId },
    },
  );

  const pendingFilesCountToTranscribe = useMemo(() => {
    const files = pendingFiles?.appointmentsByPk?.appointmentFiles;
    return files?.length ?? 0;
  }, [pendingFiles]);

  if (pendingFilesCountToTranscribe === 0) {
    return null;
  }

  return (
    <Alert variant="default" ref={(e) => e?.scrollIntoView()}>
      <LoadingIcon size="lg" className="mr-4" />
      <AlertTitle>
        {t('appointmentTools.transcription.analyzingAudio')}
      </AlertTitle>
      <AlertDescription>
        {t('appointmentTools.transcription.analyzingAudioDescription', {
          count: pendingFilesCountToTranscribe,
        })}
      </AlertDescription>
    </Alert>
  );
};
